import {Nullish} from 'shared/web';

/**
 * Represents the data structure for mapping inspection and audit IDs.
 */
export interface InspectionIdForAuditId {
  /**
   * The ID of the audit (or nullish if not available).
   */
  auditId: string | Nullish;

  /**
   * Determines whether to use the ID of the entire audit instead of the template ID
   * when connecting to Backend endpoints.
   *
   * Example usage:
   * url: '/vehicles/:id/conditions/condition'
   * endpoint: 'car-audit/v1/autofill-template/:➡️ inspectionId ⬅️/:autofillTemplateId'
   *
   * Set to `true` to use the audit ID for updating templates, `false` otherwise.
   */
  shouldUseAuditIdForUpdateTemplate: boolean;
}
